/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_graasp_library13 = /** @type {(inputs: {}) => string} */ () => {
	return `Graasp Library`
};

const fr_graasp_library13 = /** @type {(inputs: {}) => string} */ () => {
	return `Graasp Library`
};

const de_graasp_library13 = /** @type {(inputs: {}) => string} */ () => {
	return `Graasp Library`
};

const es_graasp_library13 = /** @type {(inputs: {}) => string} */ () => {
	return `Biblioteca de Graasp`
};

const it_graasp_library13 = /** @type {(inputs: {}) => string} */ () => {
	return `Biblioteca Graasp`
};

const ar_graasp_library13 = /** @type {(inputs: {}) => string} */ () => {
	return `مكتبة چراسپ`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const graasp_library13 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.graasp_library13(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("graasp_library13", locale)
	if (locale === "en") return en_graasp_library13(inputs)
	if (locale === "fr") return fr_graasp_library13(inputs)
	if (locale === "de") return de_graasp_library13(inputs)
	if (locale === "es") return es_graasp_library13(inputs)
	if (locale === "it") return it_graasp_library13(inputs)
	return ar_graasp_library13(inputs)
};
export { graasp_library13 as "GRAASP_LIBRARY" }